import $ from 'jquery';
import { debounce } from '../utils/functions';

const $window = $(window);

const table = (tableEl, index) => {
    let $table = tableEl.find('.table');

    if ($table.length === 0) {
        tableEl.find('table').wrap('<div class="table"></div>');
        $table = tableEl.find('.table');
    }

    tableOverflow($table);

    $table.off('scroll');
    $table.on('scroll', () => tableOverflow($table));

    $window.off('resize:width.wpBlockTable' + index);
    $window.on(
        'resize:width.wpBlockTable' + index,
        debounce(() => tableOverflow($table))
    );
};

const tableScrolledLeft = tableEl => tableEl.scrollLeft() === 0;
const tableScrolledRight = tableEl =>
    Math.ceil(tableEl.scrollLeft() + tableEl.outerWidth()) >= Math.ceil(tableEl[0].scrollWidth);

const tableOverflow = tableEl => {
    const $parent = tableEl.closest('.wp-block-table');

    if (tableScrolledLeft(tableEl) && tableScrolledRight(tableEl)) {
        $parent.addClass('table-is-left table-is-right');
    } else {
        tableScrolledLeft(tableEl)
            ? $parent.addClass('table-is-left')
            : $parent.removeClass('table-is-left');

        tableScrolledRight(tableEl)
            ? $parent.addClass('table-is-right')
            : $parent.removeClass('table-is-right');
    }
};

export const reloadScriptWpBlockTable = () => {
    const $tableEl = $('.wp-block-table');

    if ($tableEl.length > 0) {
        $tableEl.each(function (index) {
            table($(this), index);
        });
    }
};
reloadScriptWpBlockTable();
